if (!customElements.get('sale-cart-progress')) {
  customElements.define('sale-cart-progress', class extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.expiryTimer);
      const remaining = Number(this.dataset.endsAt) * 1000 - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) { this.hidden = true; return; }
      this.expiryTimer = setTimeout(() => { this.hidden = true; }, Math.min(remaining, 2147483647));
    }
    disconnectedCallback() { clearTimeout(this.expiryTimer); }
  });
}
